import { Factory, trait } from 'miragejs';

const buildDefaultNotificationPeriods = () => {
  return [1, 2, 3, 4, 5, 6, 7].map((day) => {
    return {
      active: [1, 2, 3, 4, 5].includes(day),
      day,
      'end-at': '18:00:00',
      'start-at': '08:00:00',
    };
  });
};

export default Factory.extend({
  active: true,

  default: trait({
    notificationPeriods: () => buildDefaultNotificationPeriods(),
  }),
});
